import cn from 'classnames';
import React, {forwardRef} from 'react';

import styles from './Input.module.scss';

interface IProps {
    type: string;
    className: string;
    value: string;
    maxLength: number;
    minLength: number;
    onChange: () => void;
    placeholder: string;
    testId?: string;
    ariaLabel?: string;
    id?: string;
}

const Input = forwardRef<HTMLInputElement, IProps>((props, ref) => {
    const {type, className, value, maxLength, minLength, onChange, placeholder, testId, ariaLabel, id} = props;
    const inputClassName = cn(styles.Input, className);

    return (
        <input
            ref={ref}
            aria-label={ariaLabel}
            className={inputClassName}
            data-testid={testId}
            id={id}
            maxLength={maxLength}
            minLength={minLength}
            onChange={onChange}
            placeholder={placeholder}
            type={type}
            value={value}
        />
    );
});

Input.displayName = 'Input';

export default Input;
